export default class Timeline {
    constructor (
        startTime,
        endTime,
        timelineBlocks,
        journeys
    ) {
        this.startTime = startTime
        this.endTime = endTime
        this.timelineBlocks = timelineBlocks
        this.journeys = journeys
    }
}
